import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import prepareAuthHeaders from "@utils/prepareAuthHeaders";
import { Plan } from "@models/plan";
import { ListResponse } from "@models/list-response";
import { PlanSubscriptionDetails } from "@models/plan-subscription-details";

const BASE_API_URL = process.env.REACT_APP_API_URL;

export const planApi = createApi({
  reducerPath: "planApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_API_URL}/plans`,
    prepareHeaders: prepareAuthHeaders,
  }),
  tagTypes: ["Subscription"],
  endpoints: (builder) => ({
    getPlans: builder.query<ListResponse<Plan>, void>({
      query: () => ({
        url: "",
        method: "GET",
      }),
    }),
    getPlanSubscriptionDetails: builder.query<
      PlanSubscriptionDetails,
      { patientId: string }
    >({
      providesTags: ["Subscription"],
      query: (params) => ({
        url: "subscription",
        method: "GET",
        params,
      }),
    }),
  }),
});

export const { useGetPlansQuery, useGetPlanSubscriptionDetailsQuery } = planApi;
